import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import IndexPage from 'flarum/forum/components/IndexPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

/**
 * The `PageHero` component displays the hero on a page page.
 *滚动发帖按钮
 * ### Props
 *
 * - `page`
 */
export default class UploadFileButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    /**
     * Whether or not an avatar upload is in progress.
     *
     * @type {Boolean}
     */
    this.loading = false;
    this.isMediaUploadButton = vnode.attrs.isMediaUploadButton || false;
    this.fileUrl = vnode.attrs.onchange() ? vnode.attrs.onchange() : `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-tianjia.png`;
    this.mainImg = '';
    
    vnode.attrs.uploader.on('uploaded', () => {
      // reset the button for a new upload
      this.$('form')[0].reset();

      // redraw to reflect uploader.loading in the DOM
      m.redraw();
    });

    vnode.attrs.uploader.on('success', ({ file, addBBcode }) => {
      if (!addBBcode) return;
      this.fileUrl = file.url();
      this.mainImg = file.url();
      vnode.attrs.onchange(file.url());
    });
  }
  view() {
    const buttonText = this.attrs.uploader.uploading
      ? app.translator.trans('fof-upload.forum.states.loading')
      : app.translator.trans('fof-upload.forum.buttons.upload');
    return (
      <Button className="TextEditor-image-container Button" onclick={this.uploadButtonClicked.bind(this)}>
        <img src={this.fileUrl} />
        {this.attrs.uploader.uploading && <LoadingIndicator size="small" display="inline" className="Button-icon" />}
        {(this.isMediaUploadButton || this.attrs.uploader.uploading) && <span className="Button-label">{buttonText}</span>}
        <form>
          <input type="file" accept=".jpg, .jpeg, .png, .bmp, .gif" multiple={false} onchange={this.process.bind(this)} />
        </form>
        {this.fileUrl !== `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-tianjia.png` ? (
          <Button
            className="delete-icon"
            onclick={(event) => {
              event.stopPropagation();
              this.fileUrl = `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btn-tianjia.png`;
              this.attrs.onchange('')
            }}
          ></Button>
        ) : (
          ''
        )}
      </Button>
    );
  }

  process(e) {
    // get the file from the input field
    const files = this.$('input').prop('files');

    if (files.length === 0) {
      // We've got no files to upload, so trying
      // to begin an upload will show an error
      // to the user.
      return;
    }

    this.attrs.uploader.upload(files, !this.isMediaUploadButton);
  }

  uploadButtonClicked(e) {
    // Trigger click on hidden input element
    // (Opens file dialog)
    this.$('input').click();
  }
}
